"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    striped: {},
    hover: {},
    table: function (_a) {
        var theme = _a.theme, captionSide = _a.captionSide;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { width: '100%', borderCollapse: 'collapse', captionSide: captionSide, color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black, lineHeight: theme.lineHeight, '& caption': {
                marginTop: captionSide === 'top' ? 0 : theme.spacing.xs,
                marginBottom: captionSide === 'bottom' ? 0 : theme.spacing.xs,
                fontSize: theme.fontSizes.sm,
                color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
            }, '& thead tr th, & tfoot tr th': {
                textAlign: 'left',
                fontWeight: 'bold',
                color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
                fontSize: 14,
                padding: [7, 10],
            }, '& thead tr th': {
                borderBottom: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]),
            }, '& tfoot tr th': {
                borderTop: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]),
            }, '& tbody tr td': {
                padding: [7, 10],
                borderBottom: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]),
                fontSize: 14,
            }, '& tbody tr:last-of-type td': {
                borderBottom: 'none',
            }, '&$striped tbody tr:nth-of-type(odd)': {
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
            }, '&$hover tbody tr:hover': {
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1],
            } }));
    },
}, { link: true });
